// Fragments avoid access logs and Referer headers, but analytics still reads
// location.href. Capture before SDK initialization and keep the bearer token
// only in module memory until the confirmation page takes it.
export const EMAIL_CHANGE_PATH = "/auth/email-change";

/** The Better Auth endpoint that redeems the token; POST only, never on GET. */
export const EMAIL_CHANGE_CONFIRM_ENDPOINT = "/api/auth/email-change/confirm";

let parkedToken: string | null = null;

/**
 * Reads the token from the fragment and removes the fragment from the address
 * bar. A fragment without a `token` is not ours and is left alone.
 */
function liftTokenFromAddressBar(): string | null {
  const { pathname, search, hash } = window.location;
  if (pathname !== EMAIL_CHANGE_PATH || hash.length < 2) {
    return null;
  }

  const token = new URLSearchParams(hash.slice(1)).get("token");
  if (token === null) {
    return null;
  }

  window.history.replaceState(window.history.state, "", `${pathname}${search}`);

  const trimmed = token.trim();
  return trimmed.length > 0 ? trimmed : null;
}

/** Runs from `instrumentation-client`, before analytics initialise. */
export function captureEmailChangeLinkToken(): void {
  const token = liftTokenFromAddressBar();
  if (token !== null) {
    parkedToken = token;
  }
}

// Hash-only navigation does not rerun instrumentation-client.
export function takeEmailChangeLinkToken(): string | null {
  const token = liftTokenFromAddressBar() ?? parkedToken;
  parkedToken = null;
  return token;
}
